import { get, post, del } from "api/axiosApi";
import { env } from "utils/env";

const url = env.REACT_APP_LEASING_API_URL; //"http://kube-w1:32751/api";

const getWarrantyData = (documentId, siteId) => {
  return get(`${url}/leasingDocument/${documentId}/${siteId}/warranties`);
};

const getWarrantySummaryData = (documentId, siteId) => {
  return get(`${url}/leasingDocument/${documentId}/${siteId}/warrantiesSummary`);
};

const getWarrantyItems = (search, warrantyTypeId) => {
  return get(`${url}/leasingDocument/warrantyitems?search=${search}&warrantyTypeId=${warrantyTypeId}`);
};

const updateWarranties = (documentId, siteId, warranties) => {
  return post(`${url}/leasingdocument/${documentId}/${siteId}/warranties/update`, { documentId, siteId, warranties });
};

const deleteWarranty = (documentId, siteId, warrantyId) => {
  return del(`${url}/leasingdocument/${documentId}/${siteId}/warranty/${warrantyId}/delete`, {
    documentId,
    siteId,
    warrantyId
  });
};

const deleteAllWarranties = (documentId, siteId) => {
  return del(`${url}/leasingdocument/${documentId}/${siteId}/warranties/deleteall`, { documentId, siteId });
};

const getWarrantyIssuer = (documentId, siteId, issuerTypeId) => {
  return get(`${url}/leasingDocument/${documentId}/${siteId}/getwarrantyissuer/${issuerTypeId}`);
};

const exp = {
  getWarrantyData,
  getWarrantySummaryData,
  updateWarranties,
  getWarrantyItems,
  deleteWarranty,
  deleteAllWarranties,
  getWarrantyIssuer
};
export default exp;
